import { observer } from 'mobx-react-lite';
import * as React from 'react';

import InfoIconImage from '../../assets/info.svg';

import './info-icon.css';

interface IProps {
    text: string;
}

export const InfoIcon = observer<IProps>((props) => {
    return (
        <div className='info-container'>
            <img src={InfoIconImage} alt='info' />
            <p>
                {props.text}
            </p>
        </div>
    );
});
